import React from 'react';
import { connect } from 'react-redux';
import { List } from 'semantic-ui-react';
import NotAuthorised from '@/components/errors/NotAuthorised';
import RoleActiveTokensListItem from './RoleActiveTokensListItem';
import RoleTokenDaysListItem from './RoleTokenDaysListItem';

const RoleTokens = ({
  code,
  category,
  canRead,
}) => {
  if (!canRead) {
    return (<NotAuthorised />);
  }

  return (
    <List className="aridhia-role-tokens">
      <RoleActiveTokensListItem code={code} category={category} />
      <RoleTokenDaysListItem code={code} category={category} />
    </List>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { read } } } },
}) => ({ canRead: read });

export default connect(mapStateToProps)(RoleTokens);
